/** The router-state shape the route guard leaves on the Login redirect: where the visitor was going. */
export interface LoginReturnState {
	from: string;
}

/**
 * Where to go after signing in, read back from the Login route's router state. Only an in-app
 * path is honoured — anything else (missing, malformed, a protocol-relative `//host`, or Login
 * itself) yields `undefined`, and the caller falls back to the default page.
 */
export function loginReturnPath(state: unknown): string | undefined {
	const from = (state as Partial<LoginReturnState> | null | undefined)?.from;
	if (typeof from !== "string" || !from.startsWith("/") || from.startsWith("//")) return undefined;
	if (from === "/" || from === "/login" || from.startsWith("/login?")) return undefined;
	return from;
}
